
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/nura",
      function () {
        return require("private-next-pages/case-study/nura.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/nura"])
      });
    }
  